function lazyLoadImg() {
    $('.lazy').Lazy();
}